function lazyLoadImg() {
    $('.lazy').Lazy();
}